import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var addAuditReportRes;
export const addAuditReportTodo = createAsyncThunk('addAuditReport', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'generate_audit_report',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "from_date": data.start_date ? data.start_date : '',
                "to_date": data.end_date ? data.end_date : '',
                "type": data.type ? data.type : '',
                "vemp_code": data.user_wise ? data.user_wise : '',
                "course_id": data.learning_module_wise ? data.learning_module_wise : '',
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return addAuditReportRes = res.data
    } catch (error) {
        return addAuditReportRes = error.response.data
    }
})